document.addEventListener('DOMContentLoaded', function () {
    'use strict';

    const QUIZ_STORAGE_KEY = 'ultimapeak_quiz_answers_v1';
    const DIRECT_GA4_ENABLED = true;

    const stepBlocks = Array.from(document.querySelectorAll('.quiz-main-blocks'));
    const backBtn = document.querySelector('.block__questionaire-quiz-back-btn a');
    let activeTimer = null;

    if (!stepBlocks.length) return;

    const quizTrackingConfig = {
        quizName: 'questionaire_funnel',
        language: (document.documentElement.lang || 'en').split('-')[0].toLowerCase()
    };

    const trackedQuizSteps = new Set();

    function getTotalSteps() {
        return stepBlocks.length;
    }

    function getStepNumber(stepElement) {
        return stepBlocks.indexOf(stepElement) + 1;
    }

    function getStepId(stepElement) {
        if (!stepElement) return '';
        return stepElement.getAttribute('data-step-id') || stepElement.id || '';
    }

    function getQuestionId(stepElement) {
        if (!stepElement) return '';
        return stepElement.getAttribute('data-question-id') || getStepId(stepElement);
    }

    function normalizeSlug(value) {
        return String(value || '')
            .trim()
            .toLowerCase()
            .replace(/&/g, ' and ')
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '')
            .slice(0, 100);
    }

    function getQuizCodeQuestion(questionId) {
        const root = window.UltimaPeakQuizCodes;
        const quizzes = root && root.quizzes;
        const quiz = quizzes && quizzes[quizTrackingConfig.quizName];
        const questions = quiz && quiz.questions;
        return questions && questions[questionId] ? questions[questionId] : null;
    }

    function getQuestionCode(questionId) {
        const question = getQuizCodeQuestion(questionId);
        return question && question.code ? String(question.code) : '';
    }

    function getAnswerCode(questionId, answerId) {
        const question = getQuizCodeQuestion(questionId);
        const answer = question && question.answers && question.answers[answerId];
        return answer && answer.code ? String(answer.code) : '';
    }

    function warnMissingQuizCode(questionId, answerId) {
        console.warn(
            'Questionnaire tracking: missing frozen quiz code; readable value was not sent.',
            { quiz: quizTrackingConfig.quizName, question: questionId, answer: answerId || '' }
        );
    }

    function readQuizStore() {
        try {
            const raw = window.sessionStorage.getItem(QUIZ_STORAGE_KEY);
            if (!raw) return { version: 1, lastQuiz: '', quizzes: {} };

            const parsed = JSON.parse(raw);
            if (!parsed || typeof parsed !== 'object') {
                return { version: 1, lastQuiz: '', quizzes: {} };
            }

            parsed.version = 1;
            parsed.quizzes = parsed.quizzes && typeof parsed.quizzes === 'object' ? parsed.quizzes : {};
            return parsed;
        } catch (error) {
            return { version: 1, lastQuiz: '', quizzes: {} };
        }
    }

    function writeQuizStore(store) {
        try {
            window.sessionStorage.setItem(QUIZ_STORAGE_KEY, JSON.stringify(store));
        } catch (error) {
            // Tracking must never interrupt the quiz if storage is unavailable.
        }
    }


    function resetQuizAnswersForNewAttempt() {
        const store = readQuizStore();
        store.lastQuiz = quizTrackingConfig.quizName;
        store.quizzes[quizTrackingConfig.quizName] = {
            answers: {},
            updatedAt: Date.now()
        };
        writeQuizStore(store);
    }

    function saveAnswer(questionId, answerId, selected, isMulti) {
        if (!questionId || !answerId) return;

        const store = readQuizStore();
        const quizName = quizTrackingConfig.quizName;
        const quizState = store.quizzes[quizName] && typeof store.quizzes[quizName] === 'object'
            ? store.quizzes[quizName]
            : { answers: {}, updatedAt: 0 };

        quizState.answers = quizState.answers && typeof quizState.answers === 'object'
            ? quizState.answers
            : {};

        if (isMulti) {
            const current = Array.isArray(quizState.answers[questionId])
                ? quizState.answers[questionId].slice()
                : [];
            const index = current.indexOf(answerId);

            if (selected && index === -1) current.push(answerId);
            if (!selected && index !== -1) current.splice(index, 1);

            if (current.length) {
                quizState.answers[questionId] = current;
            } else {
                delete quizState.answers[questionId];
            }
        } else if (selected) {
            quizState.answers[questionId] = [answerId];
        }

        quizState.updatedAt = Date.now();
        store.lastQuiz = quizName;
        store.quizzes[quizName] = quizState;
        writeQuizStore(store);
    }

    function emitQuizEvent(eventName, payload) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: eventName }, payload));

        /*
         * Fast GA4 path: theme.liquid already loads the direct Google tag.
         * Keep this enabled until GTM forwards quiz_step_view and quiz_answer.
         * Once GTM is configured to send the same events, set this to false to
         * prevent duplicate GA4 events.
         */
        if (DIRECT_GA4_ENABLED && typeof window.gtag === 'function') {
            const gaPayload = Object.assign({}, payload);
            delete gaPayload.quiz_step_url;
            window.gtag('event', eventName, gaPayload);
        }
    }

    function getStepFromUrl() {
        try {
            const value = Number(new URL(window.location.href).searchParams.get('step'));
            return Number.isInteger(value) && value >= 1 && value <= getTotalSteps() ? value : 1;
        } catch (error) {
            return 1;
        }
    }

    function updateStepUrl(stepElement, mode) {
        try {
            const step = getStepNumber(stepElement);
            const stepId = getStepId(stepElement);
            const url = new URL(window.location.href);
            url.searchParams.set('step', String(step));

            const nextUrl = url.pathname + url.search + url.hash;
            const state = {
                quizName: quizTrackingConfig.quizName,
                quizStep: step,
                quizStepId: stepId
            };

            if (mode === 'push') {
                window.history.pushState(state, '', nextUrl);
            } else {
                window.history.replaceState(state, '', nextUrl);
            }
        } catch (error) {
            console.warn('Questionnaire tracking: unable to update URL.', error);
        }
    }

    function pushQuizStepEvent(stepElement) {
        const step = getStepNumber(stepElement);
        const stepId = getStepId(stepElement);
        const trackingKey = quizTrackingConfig.quizName + ':' + stepId;

        if (!stepId || trackedQuizSteps.has(trackingKey)) return;

        trackedQuizSteps.add(trackingKey);
        emitQuizEvent('quiz_step_view', {
            quiz_name: quizTrackingConfig.quizName,
            quiz_step: step,
            quiz_step_id: stepId,
            quiz_total_steps: getTotalSteps(),
            quiz_language: quizTrackingConfig.language,
            quiz_page: window.location.pathname,
            quiz_step_url: window.location.href
        });
    }

    function pushQuizAnswerEvent(stepElement, answerId, selected, isMulti) {
        if (!stepElement || !answerId) return;

        const step = getStepNumber(stepElement);
        const stepId = getStepId(stepElement);
        const questionId = getQuestionId(stepElement);

        saveAnswer(questionId, answerId, selected, isMulti);

        // Multi-select deselection only updates session storage. It must not create
        // an answer event. Selected answers are emitted with privacy-safe frozen
        // random codes only; readable health-response slugs never reach GA4.
        if (!selected) return;

        const questionCode = getQuestionCode(questionId);
        const answerCode = getAnswerCode(questionId, answerId);
        if (!questionCode || !answerCode) {
            warnMissingQuizCode(questionId, answerId);
            return;
        }

        emitQuizEvent('quiz_answer', {
            question: questionCode,
            answer: answerCode
        });
    }

    function updateBackButton() {
        if (!backBtn) return;

        const currentIndex = stepBlocks.findIndex(step => step.classList.contains('active'));

        if (currentIndex <= 0) {
            backBtn.setAttribute('href', '#');
            return;
        }

        backBtn.setAttribute('href', '#' + stepBlocks[currentIndex - 1].id);
    }

    function goToStep(targetId, dataAns, historyMode) {
        const targetStep = document.querySelector(targetId);
        if (!targetStep) return;

        if (activeTimer) {
            clearTimeout(activeTimer);
            activeTimer = null;
        }

        stepBlocks.forEach(step => step.classList.remove('active'));
        targetStep.classList.add('active');

        if (historyMode === 'push' || historyMode === 'replace') {
            updateStepUrl(targetStep, historyMode);
        }

        pushQuizStepEvent(targetStep);
        updateBackButton();

        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });

        if (dataAns) {
            document.querySelectorAll('[data-prev-step-ans]').forEach(block => {
                const blockAns = block.getAttribute('data-prev-step-ans');
                block.style.display = blockAns === dataAns ? 'block' : 'none';
            });
        }

        if (targetStep.dataset.autoNext === 'true') {
            const delay = parseInt(targetStep.dataset.delay, 10) || 5000;
            const currentIndex = stepBlocks.indexOf(targetStep);
            const nextStep = stepBlocks[currentIndex + 1];

            if (nextStep) {
                activeTimer = setTimeout(function () {
                    goToStep('#' + nextStep.id, null, 'push');
                }, delay);
            }
        }
    }

    document.addEventListener('click', function (e) {
        const btn = e.target.closest('.answer-clickable-btn, .continue-clickable-btn');
        if (!btn) return;

        const href = btn.getAttribute('href');
        if (!href || !href.startsWith('#step--')) return;

        e.preventDefault();

        if (btn.classList.contains('answer-clickable-btn')) {
            const stepElement = btn.closest('.quiz-main-blocks');
            const answerId = btn.getAttribute('data-answer-id');
            if (stepElement && answerId) {
                pushQuizAnswerEvent(stepElement, answerId, true, false);
            }
        }

        goToStep(href, btn.getAttribute('data-ans'), 'push');
    });

    if (backBtn) {
        backBtn.addEventListener('click', function (e) {
            const currentIndex = stepBlocks.findIndex(step => step.classList.contains('active'));
            if (currentIndex <= 0) return;

            e.preventDefault();
            window.history.back();
        });
    }

    window.addEventListener('popstate', function () {
        const stepNumber = getStepFromUrl();
        const targetStep = stepBlocks[stepNumber - 1];
        if (!targetStep) return;

        goToStep('#' + targetStep.id, null, null);
    });

    // A fresh visit starts a new attempt so removed/skipped questions from an
    // older attempt cannot leak into the next order. Reloads with ?step= keep
    // the current session answers intact.
    if (!new URLSearchParams(window.location.search).has('step')) {
        resetQuizAnswersForNewAttempt();
    }

    // Initial page load starts at the first rendered block. Reordering or
    // deleting blocks therefore updates the positional step automatically.
    goToStep('#' + stepBlocks[0].id, null, 'replace');

    // Optional rotating loading text. Some questionnaire variants do not have
    // this block, so guard it instead of throwing a JS error.
    const changingText = document.querySelector('.block_quiz_type_4-change-text');
    const msg = changingText ? changingText.querySelector('p') : null;

    if (changingText && msg) {
        const texts = [];
        let i = 1;

        while (changingText.dataset['text' + i]) {
            texts.push(changingText.dataset['text' + i]);
            i++;
        }

        if (texts.length) {
            let index = 0;

            function show() {
                msg.classList.remove('active');
                setTimeout(function () {
                    msg.textContent = texts[index];
                    msg.classList.add('active');
                    index = (index + 1) % texts.length;
                }, 60);
            }

            show();
            setInterval(show, 2000);
        }
    }
});
